import React from 'react'
// icons
import DeleteOutline from '@mui/icons-material/DeleteOutline'
// components
import { Input } from 'components/FormElements'
// themes
import { colors } from 'themes'
// types
import { IField } from 'types/graphql'
// views
import { AddButton, ClickOverlay, DeleteButton, Field, FieldInput, Wrapper } from './views'

const MAX_PICKLISTS = 3

interface Props {
  onAdd: () => void
  onEdit: (field: IField) => void
  onDelete: (field: IField) => void
  picklists: IField[]
}

const Picklists: React.FC<Props> = ({ picklists, onEdit, onAdd, onDelete }) => (
  <Wrapper>
    {picklists.map((field, idx) => (
      <Field key={field.id}>
        <FieldInput>
          <ClickOverlay onClick={() => onEdit(field)} />
          <Input disabled fullWidth name={field.id} value={field.label || ''} label={`Question ${idx + 4}`} />
        </FieldInput>
        <DeleteButton onClick={() => onDelete(field)}>
          <DeleteOutline htmlColor={colors.red200} fontSize='small' />
        </DeleteButton>
      </Field>
    ))}
    {picklists.length < MAX_PICKLISTS && <AddButton onClick={onAdd}>+ add picklist</AddButton>}
  </Wrapper>
)

export default Picklists
